module.exports = __webpack_public_path__ + "static/media/con_spa_res_equ.afa00691.png";